/* =========================================================
   Duty-Ready Theme — theme.js
   Uses Shopify's built-in Ajax Cart API (/cart/add.js, /cart/change.js,
   /cart.js) rather than custom endpoints. No frameworks required.
   ========================================================= */
(function () {
  'use strict';

  var moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-mobile-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.getElementById('CartDrawerBody');
        var subtotal = document.getElementById('CartDrawerSubtotal');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        updateCartCount(cart.item_count);
        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<p style="padding:24px 0;color:var(--color-text-faint);">Your cart is empty.</p>';
          return;
        }

        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-line">' +
            '<img src="' + item.image + '&width=180" alt="' + item.title.replace(/"/g, '&quot;') + '">' +
            '<div><div class="cart-line__title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
            '<div style="margin-top:8px;font-size:0.82rem;color:var(--color-text-faint);">Qty ' + item.quantity + '</div></div>' +
            '<div style="text-align:right;">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>';
        });
        body.innerHTML = html;
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (Ajax) ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = document.getElementById('AddToCartBtn');
      var formData = new FormData(productForm);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Added ✓'; setTimeout(function () { submitBtn.textContent = submitBtn.dataset.originalText; }, 1500); }
          openCartDrawer();
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  }

  var buyNowBtn = document.querySelector('[data-buy-now]');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      if (buyNowBtn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function () { window.location.href = '/cart/checkout'; });
    });
  }

  /* ---------- Quantity steppers (product page) ---------- */
  var qtyInput = document.getElementById('ProductQuantity');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1); });
    qtyPlus.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1; });
  }

  /* ---------- Cart page quantity changes (Ajax /cart/change.js) ---------- */
  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var delta = btn.hasAttribute('data-cart-qty-minus') ? -1 : 1;
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = newQty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Variant selection (uses embedded variants JSON, no custom API) ---------- */
  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  if (variantsJsonEl) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    var optionGroups = document.querySelectorAll('.option-selector__values[data-option-index]');
    var variantIdInput = document.getElementById('ProductVariantId');
    var addToCartBtn = document.getElementById('AddToCartBtn');

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.option-value.is-selected');
        selected.push(active ? active.getAttribute('data-option-value') : null);
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      var priceEl = document.querySelector('.product-info__price .price');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.option-value').forEach(function (b) {
            b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
          var variant = findMatchingVariant(getSelectedOptions());
          updateForVariant(variant);
        });
      });
    });
  }

  /* ---------- Gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active'); thumb.setAttribute('aria-selected', 'true');
    });
  });

  /* ---------- Mega menu ---------- */
  document.querySelectorAll('[data-mega-item]').forEach(function (item) {
    var trigger = item.querySelector('.mega-nav__trigger');
    if (!trigger) return;
    function open() { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    trigger.addEventListener('click', function () { item.classList.contains('is-open') ? close() : open(); });
    trigger.addEventListener('focus', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.mega-nav__item.is-open').forEach(function (item) {
      if (!item.contains(e.target)) { item.classList.remove('is-open'); }
    });
  });

  /* ---------- Product zoom lightbox ---------- */
  var zoomLightbox = document.getElementById('ZoomLightbox');
  var zoomImage = document.getElementById('ZoomLightboxImage');
  document.querySelectorAll('[data-zoom-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (!mainImg || !zoomLightbox || !zoomImage) return;
      zoomImage.src = mainImg.getAttribute('data-zoom-src') || mainImg.src;
      zoomImage.alt = mainImg.alt;
      zoomLightbox.classList.add('is-open');
      zoomLightbox.setAttribute('aria-hidden', 'false');
    });
  });
  function closeZoom() {
    if (!zoomLightbox) return;
    zoomLightbox.classList.remove('is-open');
    zoomLightbox.setAttribute('aria-hidden', 'true');
  }
  document.querySelectorAll('[data-zoom-close]').forEach(function (btn) { btn.addEventListener('click', closeZoom); });
  if (zoomImage) zoomImage.addEventListener('click', closeZoom);

  /* ---------- Gallery: images + video/model media ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaType = thumb.getAttribute('data-media-type');
      var mainMediaContainer = document.getElementById('ProductMainMedia');
      var mainImg = document.getElementById('ProductMainImage');

      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active'); thumb.setAttribute('aria-selected', 'true');

      if (mediaType === 'video' || mediaType === 'external_video') {
        var store = document.querySelector('#ProductMediaStore [data-media-id="' + thumb.getAttribute('data-media-id') + '"]');
        var zoomContainer = document.querySelector('[data-zoom-container]');
        if (store && zoomContainer) {
          zoomContainer.querySelectorAll('img, .product-gallery__zoom-btn, #ProductMainMedia').forEach(function (el) { el.remove(); });
          var wrapper = document.createElement('div');
          wrapper.id = 'ProductMainMedia';
          wrapper.innerHTML = store.innerHTML;
          zoomContainer.prepend(wrapper);
        }
      } else if (mainImg) {
        mainImg.src = thumb.getAttribute('data-full');
        mainImg.setAttribute('data-zoom-src', thumb.getAttribute('data-full'));
        if (mainMediaContainer) mainMediaContainer.remove();
      }
    });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      if (answer) answer.hidden = isOpen;
    });
  });

  /* ---------- Product recommendations (native Shopify API) ---------- */
  var recsEl = document.querySelector('[data-product-recommendations]');
  if (recsEl) {
    fetch(recsEl.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recommendations-grid]');
        var target = recsEl.querySelector('[data-recommendations-grid]');
        if (grid && target && grid.children.length) {
          target.innerHTML = grid.innerHTML;
        } else {
          recsEl.style.display = 'none';
        }
      })
      .catch(function () { recsEl.style.display = 'none'; });
  }

  /* ---------- Recently viewed (localStorage + built-in {handle}.js API) ---------- */
  (function recentlyViewed() {
    var STORAGE_KEY = 'recently_viewed_handles';
    var current = document.body.getAttribute('data-product-handle');
    var stored = [];
    try { stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { stored = []; }

    if (current) {
      stored = stored.filter(function (h) { return h !== current; });
      stored.unshift(current);
      stored = stored.slice(0, 8);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(stored)); } catch (e) {}
    }

    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var toRender = stored.filter(function (h) { return h !== current; }).slice(0, 4);
    if (toRender.length === 0) return;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    Promise.all(toRender.map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.filter(Boolean).forEach(function (p) {
        var img = p.featured_image ? p.featured_image.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png') : '';
        html += '<a href="' + p.url + '" class="product-card">' +
          '<div class="product-card__media">' + (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') + '</div>' +
          '<div class="product-card__body"><div class="product-card__title">' + p.title + '</div>' +
          '<div class="price">' + formatMoney(p.price) + '</div></div></a>';
      });
      if (html && grid) { grid.innerHTML = html; section.hidden = false; }
    });
  })();

  /* ---------- Selling plan (subscription) toggle ---------- */
  document.querySelectorAll('[data-selling-plan-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var input = document.getElementById('SellingPlanId');
      if (input) input.value = radio.value;
    });
  });

  /* ---------- Shipping restriction checker ---------- */
  var shippingModal = document.getElementById('ShippingCheckModal');
  document.querySelectorAll('[data-open-shipping-check]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (shippingModal) { shippingModal.classList.add('is-open'); shippingModal.setAttribute('aria-hidden', 'false'); }
    });
  });
  document.querySelectorAll('[data-shipping-check-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (shippingModal) { shippingModal.classList.remove('is-open'); shippingModal.setAttribute('aria-hidden', 'true'); }
    });
  });
  var shippingStateSelect = document.getElementById('ShippingCheckState');
  if (shippingStateSelect) {
    shippingStateSelect.addEventListener('change', function () {
      var state = shippingStateSelect.value;
      var noteEl = document.querySelector('.shipping-restriction-note');
      var restricted = noteEl ? (noteEl.getAttribute('data-restricted-states') || '').split(',') : [];
      var resultEl = document.getElementById('ShippingCheckResult');
      if (!resultEl) return;
      if (restricted.indexOf(state) > -1) {
        resultEl.innerHTML = '<span class="shipping-check-result shipping-check-result--bad">This item cannot currently ship to ' + state + '.</span>';
      } else if (state) {
        resultEl.innerHTML = '<span class="shipping-check-result shipping-check-result--good">Good news — this item ships to ' + state + '.</span>';
      } else {
        resultEl.innerHTML = '';
      }
    });
  }

  /* ---------- Cart-level shipping restriction summary ---------- */
  var cartRestrictedEl = document.querySelector('[data-cart-restricted-items]');
  if (cartRestrictedEl) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var flagged = cart.items.filter(function (item) {
        return item.product_tags && item.product_tags.some(function (t) { return t.indexOf('restricted:') === 0; });
      });
      if (flagged.length > 0) {
        cartRestrictedEl.hidden = false;
        cartRestrictedEl.querySelector('[data-cart-restricted-list]').textContent =
          flagged.map(function (i) { return i.product_title; }).join(', ');
      }
    }).catch(function () {});
  }

  /* ---------- Kit builder ---------- */
  document.querySelectorAll('[data-kit-builder]').forEach(function (kit) {
    var addBtn = kit.querySelector('[data-kit-add-btn]');
    var totalEl = kit.querySelector('[data-kit-total]');
    var checkboxes = kit.querySelectorAll('[data-kit-item]');

    function recalcTotal() {
      var total = 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked || cb.disabled) total += parseFloat(cb.getAttribute('data-price')) || 0;
      });
      if (totalEl) totalEl.textContent = formatMoney(Math.round(total * 100));
    }
    checkboxes.forEach(function (cb) { cb.addEventListener('change', recalcTotal); });
    recalcTotal();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        checkboxes.forEach(function (cb) {
          if (cb.checked || cb.disabled) items.push({ id: parseInt(cb.getAttribute('data-variant-id'), 10), quantity: 1 });
        });
        if (items.length === 0) return;
        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () {
            addBtn.textContent = 'Added ✓';
            setTimeout(function () { addBtn.disabled = false; addBtn.textContent = originalText; }, 1500);
            openCartDrawer();
          })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = originalText; });
      });
    }
  });

  /* ---------- Launcher finder quiz ---------- */
  var quiz = document.querySelector('[data-launcher-quiz]');
  if (quiz) {
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var answers = {};
    function showStep(index) {
      steps.forEach(function (s, i) { s.hidden = i !== index; });
    }
    showStep(0);
    quiz.querySelectorAll('[data-quiz-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-quiz-step]');
        var stepIndex = Array.prototype.indexOf.call(steps, step);
        answers[step.getAttribute('data-quiz-step')] = btn.getAttribute('data-quiz-value');

        if (stepIndex < steps.length - 2) {
          showStep(stepIndex + 1);
        } else {
          // last question answered -> show result step, pick matching result block
          var resultStep = steps[steps.length - 1];
          var results = resultStep.querySelectorAll('[data-quiz-result]');
          var matched = null;
          results.forEach(function (r) {
            var match = r.getAttribute('data-quiz-match').split('|');
            var allMatch = match.every(function (pair) {
              var kv = pair.split(':');
              return answers[kv[0]] === kv[1];
            });
            if (allMatch && !matched) matched = r;
          });
          results.forEach(function (r) { r.hidden = true; });
          var fallback = resultStep.querySelector('[data-quiz-result-default]');
          if (matched) { matched.hidden = false; } else if (fallback) { fallback.hidden = false; }
          showStep(steps.length - 1);
        }
      });
    });
    quiz.querySelectorAll('[data-quiz-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () { answers = {}; showStep(0); });
    });
  }

  /* ---------- Close drawers on Escape ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCartDrawer(); closeZoom(); if (mobileNav) mobileNav.classList.remove('is-open'); }
  });
})();
